import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'outline';
  children: React.ReactNode;
  withArrow?: boolean;
}
export function Button({
  variant = 'primary',
  children,
  className = '',
  withArrow = false,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-sm font-bold tracking-wide transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-lime-500 focus:ring-offset-2';
  const variants = {
    primary: 'bg-black text-white hover:bg-[#84cc16] hover:text-black border border-transparent',
    outline: 'bg-transparent text-black border-2 border-black hover:bg-black hover:text-white'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${className}`} {...props} data-id="element-78">
      {children}
      {withArrow && <ArrowRight className="ml-2 h-4 w-4" data-id="element-79" />}
    </motion.button>;
}